import './ErrorBoundary.scss';

export { default } from './ErrorBoundary';
